export default {
  ADMIN: '系统管理员',
  ROUTE: '航线人员',
  ROUTE_MANAGER: '航线经理',
  LINE_OPERATION: '航线操作',
  LINE_MANAGER: '航线经理',
  CUSTOMER_SERVICE: '客服人员',
  SERVICE: '客服人员',
  SERVICE_MANAGER: '客服经理',
  SALES: '销售人员',
  SALES_MANAGER: '销售经理',
  FINANCE: '财务人员',
  MANAGEMENT: '管理层',
  DISPATCHER: '调度员',
  CS: '客服',
  OPS: '航线',
  SYSTEM: '系统',
}
